import React from 'react';

const FormContext = React.createContext();

export default FormContext;